import notification from "../../../assets/img/notification.svg"
import whitelist from "../../../assets/img/whitelist.svg"
import metadata from "../../../assets/img/metadata.svg"


export const menuSystem = [
  {
    url: "/admin/system/notifications",
    icon: notification,
    title: "Notification",
    description: "Set up and manage system alerts and user notifications",
  },
  {
    url: "/admin/system/white-email",
    icon: whitelist,
    title: "Whitelist",
    description: "Control user access with email or domain whitelisting",
  },
  {
    url: "/admin/system/metadata",
    icon: metadata,
    title: "Metadata",
    description: "Manage backend tags, types, and structural definitions",
  },
]